import { useEffect } from "react";

// Injects JSON-LD structured data (Product or JobPosting) for SEO while a listing is shown.
export function useListingJsonLd(listing) {
  useEffect(() => {
    if (!listing) return;
    const img = (listing.images || []).find((i) => typeof i === "string" && i.startsWith("http"));
    let ld;
    if (listing.category === "Jobs") {
      const specs = listing.specs || {};
      const empMap = { "full-time": "FULL_TIME", "full time": "FULL_TIME", "part-time": "PART_TIME", "part time": "PART_TIME", contract: "CONTRACTOR", temporary: "TEMPORARY", internship: "INTERN", intern: "INTERN" };
      const nums = String(specs.Salary || "").match(/\d[\d,]{2,}/g)?.map((n) => parseInt(n.replace(/,/g, ""), 10)) || [];
      const created = listing.created_at ? new Date(listing.created_at) : null;
      ld = {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        title: listing.title,
        description: (listing.description || "").slice(0, 5000),
        url: window.location.href,
        directApply: true,
        hiringOrganization: { "@type": "Organization", name: listing.seller_name || "DealShed Employer" },
        jobLocation: { "@type": "Place", address: { "@type": "PostalAddress", addressLocality: listing.county, addressRegion: listing.county, addressCountry: "IE" } },
        ...(created ? { datePosted: created.toISOString().slice(0, 10), validThrough: new Date(created.getTime() + 30 * 864e5).toISOString().slice(0, 10) } : {}),
        ...(empMap[String(specs.Type || "").trim().toLowerCase()] ? { employmentType: empMap[String(specs.Type).trim().toLowerCase()] } : {}),
        ...(nums.length ? { baseSalary: { "@type": "MonetaryAmount", currency: "EUR", value: { "@type": "QuantitativeValue", unitText: "YEAR", ...(nums.length >= 2 ? { minValue: Math.min(...nums), maxValue: Math.max(...nums) } : { value: nums[0] }) } } } : {}),
      };
    } else {
      ld = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: listing.title,
        description: (listing.description || "").slice(0, 500),
        category: listing.subcategory ? `${listing.category} > ${listing.subcategory}` : listing.category,
        url: window.location.href,
        ...(img ? { image: [img] } : {}),
        ...(listing.price
          ? {
              offers: {
                "@type": "Offer",
                price: Math.round(listing.price),
                priceCurrency: "EUR",
                availability: "https://schema.org/InStock",
                url: window.location.href,
                areaServed: { "@type": "AdministrativeArea", name: listing.county },
              },
            }
          : {}),
      };
    }
    let el = document.getElementById("ld-json-listing");
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = "ld-json-listing";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(ld);
    return () => { document.getElementById("ld-json-listing")?.remove(); };
  }, [listing]);
}
